<template>
  <div class="appBg">
 
      <div class="fireFighting bg">
        <router-link :to="'/group_basic_info'">
          <div class="top_nav">
            <p> 智慧消防可视化</p>
          </div>
        </router-link>
        <div class="content">
          <div class="leftBox">
            <!-- 
       -->
            <div class="lefttop3">
              <p class="title">设备在线情况</p>

              <div>
                <li class="left3Btn">
                  <img src="@/assets/fireFighting/new/lefttop3-1.png"
                       alt="">
                  <div style="width:84px">
                    <span>接入设备总数</span>
                    <em class="fc2 fs24">{{allCount }}</em>

                  </div>
                </li>
                <li class="left3Btn mt12">
                  <img src="@/assets/fireFighting/new/lefttop3-1.png"
                       alt="">
                  <div style="width:84px">
                    <span>在线设备总数</span>
                    <em class="fc2 fs24">{{onlineData.Online}}</em>
                  </div>
                </li>
              </div>
              <div class="line"></div>
              <li style="width: 156px;">
                <el-progress class="block"
                             type="circle"
                             :percentage="rate"
                             color="#0072FF"
                             :format="textFormat"
                             text-color="rgba(230, 186, 85, 1)"
                             :width="100"
                             define-back-color="RGBA(1, 34, 94, 1)"></el-progress>
                <span class="fc1 alignCenter">设备在线率</span>
              </li>
            </div>
            <div class="left2 "
                 style="">
              <p class="title">学校设备列表</p>
              <!-- 350px 32.4vh -->
              <div :style="onLineSchool.length > 0?'overflow: hidden;flex:1;':'overflow: hidden;flex:1;display: flex;justify-content: space-around;align-items: center'">
                <vueSeamlessScroll v-if="onLineSchool.length > 0"
                                   :data="onLineSchool"

                                   :class-option="defaultOption"
                                   class="seamless-warp">
                  <ul>
                    <li class="  right4_item"
                        v-for="(item,index) in onLineSchool"
                        :key="index">
                      <img
                          v-if="item.onlineStatus==1"
                          style="width: 20px;height: 20px;margin-right: 10px;"
                           src="@/assets/onLineStatus.png"
                      />
                      <img
                          v-if="item.onlineStatus==2"
                          style="width: 20px;height: 20px;margin-right: 10px;"
                          src="@/assets/offLineStatus.png"
                      />
                      <span class="line lineWidth">{{ item.storeName }}</span>
                      <span class="line resourceName resourceNameWidth">{{ item.deviceName }}</span>
<!--                      <div class="danger">{{ item.onlineStatus }}</div>-->

                      <!-- <img class="danger"
                           src="@/assets/fireFighting/new/danger.png"
                          />
                      <img class="waring"
                           src="@/assets/fireFighting/new/waring.png"
                           v-else-if="item.alarmLevel==2" />
                      <img v-else class="waring"
                           src="@/assets/fireFighting/new/other.png"
                            /> -->
                    </li>
                  </ul>
                </vueSeamlessScroll>

                <div class="tipText" v-else>
                  暂无数据
                </div>
              </div>
              
            </div>
            <div class=" centerLeft left3">
              <p class="title">气候因素影响分析</p>
              <div id="echarts3"></div>
            </div>
            <!-- <div class="left4">
          <p class="title">警力数据</p>
          <ul class="police">
            <li class="policeItem"  v-for="(item,index) in policeData" :key="index">
              <span  :class="index == policeActive?'active':''" @click="policeActive = index">{{ item.label }}</span>
            
            </li>
           
          </ul>
          <div class="flex-between padding56">
              <div class="left4Bottom flex-column-center">
                <img src="@/assets/fireFighting/new/left4-5.png" alt="">
                <em class="fc2 fs20">5000</em>
                <em class="fc1 fs12">消防救援</em>
              </div>
              <div class="left4Bottom  flex-column-center">
                <img src="@/assets/fireFighting/new/left4-5.png" alt="">
                <em class="fc2 fs20">5000</em>
                <em class="fc1 fs12">消防救援</em>
              </div>
            </div>
        </div> -->
          </div>
          <div class="contentBox">
            <div class="adress">
              <!-- <img style="width: 775px;height: auto;"
                   src="@/assets/fireFighting/new/address.png"
                   alt=""> -->
              <div class="bottom floatB">
                <span>安全管理</span>
                <div>8.1 <span>分</span></div>
              </div>
              <div class="float_right1 floatB">
                <span>安全教育</span>
                <div>9.1 <span>分</span></div>
              </div>
              <div class="float_left1 floatB">
                <span>组织领导</span>
                <div>2.1 <span>分</span></div>
              </div>
              <div class="top floatB">
                <span>主动防御</span>
                <div>8.1 <span>分</span></div>
              </div>
              <div class="float_right2 floatB">
                <span>制度建设</span>
                <div>9.1 <span>分</span></div>
              </div>
              <div class="float_left2 floatB">
                <span>基础建设</span>
                <div>2.1 <span>分</span></div>
              </div>

              <div class="middle">
                <!-- <img src="@/assets/fireFighting/new/middle.png" alt=""> -->
                <strong>6.6</strong>
                <p>综合评分</p>

              </div>
            </div>
            <div class="flex"
                 style="position: relative;">
              <div class="centerLeft flex">
                <p class="title">日常设备巡查记录</p>
                <div id="echartsCenterLeft"></div>
              </div>
              <div class="centerLeft flex-between"
                   style="padding: 16px 16px 0 7px;">
                <p class="title">学校安全评分排名</p>
                <!-- 260px 24vh -->
                <div style="height:210px;overflow: hidden;">
                  <vueSeamlessScroll v-if="schollRank.length > 0"
                                     :data="schollRank"
                                     :class-option="defaultOption"
                                     class="seamless-warp">
                    <ul>
                      <li class="fc1 fs12 schoolSafe"
                          v-for="(item,index) in schollRank"
                          :key="index">
                        
                        <img class="danger"
                             src="@/assets/fireFighting/sc1.png"
                             v-if="index==0" />
                        <img class="danger"
                             src="@/assets/fireFighting/sc2.png"
                             v-else-if="index==1" />
                        <img class="danger"
                             src="@/assets/fireFighting/sc3.png"
                             v-else-if="index==2" />
                         <div  v-else  class="sort">
                            {{ index+1 }}
                         </div>    
                       
                        <p>{{item.schoolName}}</p>
                        <span :class="index==0?' smallBox frist' : index==1?'smallBox second':index==2?'smallBox third':'smallBox'" ></span>
                        <div :class="index==0?' line frist' : index==1?'line second':index==2?'line third':'line'"></div>
                        <div class="boxContainer">
                          <span :class="index==0?' smallBox frist' : index==1?'smallBox second':index==2?'smallBox third':'smallBox'"
                                v-for="(i,n) in 20"
                                :key="n"></span>
                        </div>
                        <span  :class="index==0?'  fristColor' : index==1?' secondColor':index==2?' thirdColor':''">{{item.score}}</span>
                      </li>
                    </ul>
                  </vueSeamlessScroll>
                </div>

              </div>
            </div>

          </div>
          <div class="rightBox">
<!--            <div class="right1">-->
<!--              <p class="title">今日设备报警处理</p>-->
<!--              <ul>-->
<!--                <li class=" ">-->
<!--                  <div class="flex-between textBox">-->
<!--                    <span class="fc1">报警</span>-->
<!--&lt;!&ndash;                     <em :style="{width:item.value*10+'px'}"></em> &ndash;&gt;-->
<!--                    <strong style="color: rgba(0, 255, 249, 1);">{{ todayNum.alarm }}</strong>-->
<!--                  </div>-->
<!--                  <div class="progess">-->
<!--                    <img -->
<!--                         :style="'left:'+98+ '%'"-->
<!--                         src="@/assets/fireFighting/new/fk.png"-->
<!--                         alt="">-->
<!--                    <div class="progessLine1"></div>-->
<!--                  </div>-->
<!--                </li>-->
<!--                <li class=" ">-->
<!--                  <div class="flex-between textBox">-->
<!--                    <span class="fc1">处理</span>-->
<!--                    &lt;!&ndash; <em :style="{width:item.value*10+'px'}"></em> &ndash;&gt;-->
<!--                    <strong style="color: rgba(1, 245, 156, 1);">{{ todayNum.handle }}</strong>-->
<!--                  </div>-->
<!--                  <div class="progess">-->
<!--                    <img -->
<!--                         :style="'left:'+((todayNum.handle/todayNum.alarm)*100-2)+ '%'"-->
<!--                         src="@/assets/fireFighting/new/fk.png"-->
<!--                         alt="">-->
<!--                         &lt;!&ndash; v-if="todayNum.handle>0" &ndash;&gt;-->
<!--                         &lt;!&ndash; (todayNum.handle/todayNum.alarm) &ndash;&gt;-->
<!--                    <div :style="'height:3px; width:'+(todayNum.handle/todayNum.alarm)*100+ '%'"-->
<!--                         class="progessLine2"></div>-->
<!--                  </div>-->
<!--                </li>-->
<!--                <li class=" ">-->
<!--                  <div class="flex-between textBox">-->
<!--                    <span class="fc1">未处理</span>-->
<!--                    &lt;!&ndash; <em :style="{width:item.value*10+'px'}"></em> &ndash;&gt;-->
<!--                    <strong style="color: rgba(254, 73, 0, 1);">{{ todayNum.unprocessed }}</strong>-->
<!--                  </div>-->
<!--                  <div class="progess">-->
<!--                    <img v-if="todayNum.unprocessed>0"-->
<!--                         :style="'left:'+((todayNum.unprocessed/todayNum.alarm)*100-2)+'%'"-->
<!--                         src="@/assets/fireFighting/new/fk.png"-->
<!--                         alt="">-->
<!--                    <div :style="'max-width:100%; height:3px; width:'+(todayNum.unprocessed/todayNum.alarm)*100+ '%'"-->
<!--                         class="progessLine3"></div>-->
<!--                  </div>-->
<!--                </li>-->
<!--              </ul>-->

<!--            </div>-->
            <div class="right2">
              <p class="title">报警类型</p>
              <div id="echarts1"
                   style="width:400px;height:200px;"></div>
            </div>

            <div class="right3"
                 style="padding: 40px  20px;">
              <p class="title">报警信息</p>
              <div :style="tsList.length>0?'flex:1;overflow: hidden;':'flex:1;overflow: hidden;display: flex;justify-content: space-around;align-items: center'">
                <vueSeamlessScroll v-if="tsList.length > 0"
                                   :data="tsList"

                                   :class-option="defaultOption"
                                   class="seamless-warp">
                  <ul>
                    <li class="  right4_item"
                        v-for="(item,index) in tsList"
                        :key="index">
                      <div
                          class="danger">{{ formatDate(item.alarmTime) }}</div>
                      <!--                    <div v-if="item.alarmLevel==3"-->
                      <!--                         class="danger">{{ formatDate(item.alarmTime) }}</div>-->
                      <!--                    <div v-else-if="item.alarmLevel==2"-->
                      <!--                         class="waring">{{ formatDate(item.alarmTime) }}</div>-->
                      <!--                    <div v-else-->
                      <!--                         class="default">{{ formatDate(item.alarmTime) }}</div>-->

                      <!-- <img class="danger"
                           src="@/assets/fireFighting/new/danger.png"
                          />
                      <img class="waring"
                           src="@/assets/fireFighting/new/waring.png"
                           v-else-if="item.alarmLevel==2" />
                      <img v-else class="waring"
                           src="@/assets/fireFighting/new/other.png"
                            /> -->

                      <span class="line">{{ item.schoolName }}</span>
                      <span class="line resourceName">{{ item.resourceName }}</span>
                      <!--                    <span :class="item.alarmLevel==3?'dangerColor':item.alarmLevel==2?'warnColor':''">{{ item.alarmType=="200001"?'烟雾报警':'其他报警' }}</span>-->
                      <span class="dangerColor">{{ item.alarmType=="200001"?'烟雾报警':'其他报警' }}</span>

                    </li>
                  </ul>
                </vueSeamlessScroll>
                <div v-else class="tipText">暂无数据</div>

              </div>

            </div>
            <div class="right4 "
                 :style="importantNews.length>0?'overflow: hidden;':'overflow: hidden;display: flex;justify-content: space-around;align-items: center'">

              <p class="title">消防器材过期提醒</p>
              <vueSeamlessScroll v-if="importantNews.length > 0"
                                 :data="importantNews"
                                 :class-option="defaultOption"
                                 class="seamless-warp">
                <ul>
                  <li class="fc1 fs12"
                      v-for="(item,index) in importantNews"
                      style="margin-top:7px;display:flex;"
                      :key="index">

                    <img class="danger"
                         src="@/assets/fireFighting/new/ygq.png"
                         v-if="item.state=='1'" />
                    <img class="waring"
                         src="@/assets/fireFighting/new/jjgq.png"
                         v-if="item.state=='2'" />
                    <span  class="line1" style="margin-left: 7px;display:inline-block;max-width:100px;overflow:hidden;text-overflow: ellipsis;white-space:nowrap">{{ item.schoolName }}</span>
                    <span style="display:inline-block;margin-left: 2px;max-width:200px;overflow:hidden;text-overflow: ellipsis;white-space:nowrap" v-if="item.content" > , {{ item.content }}</span>
                  </li>
                </ul>
              </vueSeamlessScroll>
              <div class="tipText">暂无数据</div>


            </div>
          </div>
        </div>
        <div class="footer"
             style="display: none;">

        </div>
      </div>
 </div>
</template>

<script>
// import protectNow from "./components/protectNow";
import Echarts from "echarts";
import drawMixin from '@/utils/drawMixin.js'
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  //mixins: [drawMixin],
  name: "",
  components: {
    vueSeamlessScroll
  },
  data () {
    return {
      eduInfo: JSON.parse(sessionStorage.getItem("eduInfo")),
      policeList: [
        { label: '报警', value: '99' },
        { label: '处理', value: '55' },
        { label: '未处理', value: '44' },
      ],
      policeActive: 0,
      policeData: [
        { label: '全部', value1: '4556', value2: '2465' },
        { label: '支队', value1: '2556', value2: '1465' },
        { label: '大队', value1: '1300', value2: '600' },
        { label: '中队', value1: '700', value2: '400' },
      ],
      fireEngine: [
        { label: '全部', value: '25' },
        { label: '待命', value: '15' },
        { label: '出动', value: '5' },
        { label: '维修', value: '5' },
      ],
      importantNew: [       // 1隐患   2报警   3其他
        // { type: '1', content: '设备A001，有烟感报警未处理' },
        // { type: '2', content: '设备B001，有烟感报警未处理' },
        // // { type: '3', content: '设备A002，有烟感隐患未处置' },
        // { type: '2', content: '设备B001，有烟感报警未处理' },
        // { type: '1', content: '设备A001，有烟感报警未处理' },
        // { type: '2', content: '设备B001，有烟感报警未处理' },
        // // { type: '3', content: '设备A002，有烟感隐患未处置' },
        // { type: '2', content: '设备B001，有烟感报警未处理' },
        // { type: '1', content: '设备A001，有烟感报警未处理' },
        // { type: '2', content: '设备B001，有烟感报警未处理' },
        // // { type: '3', content: '设备A002，有烟感隐患未处置' },
        // { type: '2', content: '设备B001，有烟感报警未处理' }
      ],
      importantNews: [       // 1隐患   2报警   3其他
        // { type: '1', content: '设备A001，有烟感报警未处理' },
        // { type: '2', content: '设备B001，有烟感报警未处理' },
        // // { type: '3', content: '设备A002，有烟感隐患未处置' },
        // { type: '2', content: '设备B001，有烟感报警未处理' },
        // { type: '1', content: '设备A001，有烟感报警未处理' },
        // { type: '2', content: '设备B001，有烟感报警未处理' },
        // // { type: '3', content: '设备A002，有烟感隐患未处置' },
        // { type: '2', content: '设备B001，有烟感报警未处理' },
        // { type: '1', content: '设备A001，有烟感报警未处理' },
        // { type: '2', content: '设备B001，有烟感报警未处理' },
        // // { type: '3', content: '设备A002，有烟感隐患未处置' },
        // { type: '2', content: '设备B001，有烟感报警未处理' }
      ],
      tsList: [],
      onlineData: {
        Offline: 0,
        Online: 0
      },
      allCount: 0,
      rate: 0,
      todayNum: {},
      schollRank:[],
      onLineSchool:[]//在线设备学校
    };
  },
  computed: {
    defaultOption () {
      return {
        step: 0.5, //步长 越大滚动速度越快
        limitMoveNum: 3, //启动无缝滚动最小数据量 this.dataList.length
        hoverStop: true, //是否启用鼠标hover控制
        direction: 1, //1 往上 0 往下
        openWatch: true, //开启data实时监听
        singleHeight: 0, //单条数据高度有值hoverStop关闭
        waitTime: 1000 //单步停止等待时间
      };
    }
  },
  created () {

    // this.getEquipmentType()

  },
  mounted () {

    this.$nextTick(() => {
      console.log(JSON.parse(this.$store.state.eduInfo))
      let defaultFrom = {
        eduId: JSON.parse(this.$store.state.eduInfo).eduId,
        regionCode: JSON.parse(this.$store.state.eduInfo).regionCode,
        eduType: JSON.parse(this.$store.state.eduInfo).eduBuresuType,
      }
      let form = {
        pageSize: 20,
        pageNum: 1,
        ...defaultFrom

      }
      console.log(form)
      // this.$Http.eduAlarmList(form).then(res => {
      //   this.tsList = res.data.list
      // })
      // 获取在线设备
      this.$Http.onlineStatics({eduId: this.$store.getters.getEduData.eduId}).then((res) => {
        if(res.code==200){
          this.onlineData = res.data.data
          this.allCount = this.onlineData.Online + this.onlineData.Offline
          this.rate = Number(((this.onlineData.Online / this.allCount) * 100).toFixed(2))
        }else{
          this.onlineData.online=0
          this.allCount=0
          this.rate=0
        }
      })
      // this.$Http.eduStatistics(defaultFrom).then(res => {
      //   this.onlineData = res.data
      //   this.allCount = this.onlineData.onLine + this.onlineData.offLine
      //   this.rate = Number(((this.onlineData.onLine / this.allCount) * 100).toFixed(0))
      //
      // })
      // this.$Http.todayStatistics(defaultFrom).then(res => {
      //   this.todayNum = res.data
      // })
      // 获取设备在线学校getDeviceSchoolListQuery
      this.$Http.getDeviceSchoolListQuery({eduId: this.$store.getters.getEduData.eduId}).then(res => {
        console.log(res,'====getDeviceSchoolListQuery');
        if(res.code==200){
          this.onLineSchool=res.data
        }else{
          this.onLineSchool=[]
        }

      })
      this.$Http.schollRanking(defaultFrom).then(res => {
        this.schollRank = res.data
      })
      this.$Http.equipmentexpiration(defaultFrom).then(res => {
        if(res.code==200){
          this.importantNews = res.data
        }

      })
      this.pieInit();
      // this.categoryInit();
      this.axisInit();
      this.centerLeftInit()
      // this.getequipment()
    //   获取报警信息
      this.getDataList()
      
    });
  },
  watch: {},
  methods: {
    formatDate(timestamp) {
      if (String(timestamp).length !== 13) {
        throw new Error("时间戳应为13位");
      }
      const date = new Date(timestamp);
      // 提取年、月、日
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    timestampToYMDHMS(timestamp) {
      var date = new Date(timestamp);
      var year = date.getFullYear();
      var month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份是从0开始的
      var day = ('0' + date.getDate()).slice(-2);
      var hours = ('0' + date.getHours()).slice(-2);
      var minutes = ('0' + date.getMinutes()).slice(-2);
      var seconds = ('0' + date.getSeconds()).slice(-2);
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    //获取报警信息
    async getDataList() {
      let res = await this.$Http.resourceInformation({
        eduId: this.$store.getters.getEduData.eduId,
        pageNum: 1,
        pageSize: 500,
      });
      if (res.code == 200) {
        res.data.list.forEach(item=>{
          item.alarmTime=Number(item.alarmTime)
        })
        this.tsList = res.data.list;
      } else if (res.code == 101) {
        this.tsList = [];
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    textFormat(val){
      console.log(val)
      
      return  val+'%'
    },
    timeFormate (timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month =
        new Date(timeStamp).getMonth() + 1 < 10
          ? "0" + (new Date(timeStamp).getMonth() + 1)
          : new Date(timeStamp).getMonth() + 1;
      let date =
        new Date(timeStamp).getDate() < 10
          ? "0" + new Date(timeStamp).getDate()
          : new Date(timeStamp).getDate();
      let hh =
        new Date(timeStamp).getHours() < 10
          ? "0" + new Date(timeStamp).getHours()
          : new Date(timeStamp).getHours();
      let mm =
        new Date(timeStamp).getMinutes() < 10
          ? "0" + new Date(timeStamp).getMinutes()
          : new Date(timeStamp).getMinutes();
      let ss =
        new Date(timeStamp).getSeconds() < 10
          ? "0" + new Date(timeStamp).getSeconds()
          : new Date(timeStamp).getSeconds();
      let week = new Date(timeStamp).getDay();
      let weeks = ["日", "一", "二", "三", "四", "五", "六"];
      let getWeek = "星期" + weeks[week];
      let nowTime =

        month +
        "-" +
        date 
       
      console.log(nowTime)
      return nowTime
    },
    computesTime (time) {
      console.log(time)
      var timess = new Date(time).getTime()
      return this.timeFormate(timess)
    },
    centerLeftInit () {
      let chartDom = document.getElementById('echartsCenterLeft');
      let myChart = Echarts.init(chartDom);
      let option = {
        tooltip: {
          show:false,
          trigger:'item',
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        graphic: [
          {
          type: 'text',//控制内容为文本文字
          left: '33%',
          top: '40%',//调整距离盒子高处的位置
          style: {
            fill: '#fff',//控制字体颜色
            text: '0',//控制第一行字显示内容
            fontSize: '24',
          }
        }, 
        {
          type: 'text',
          left: '28%',
          top: '50%',//调整距离盒子高处的位置
          z: 10,
          style: {
            text: '类型总数',
            font: 'Microsoft YaHei',
            fontSize: '16',
            lineHeight: 15,
            fill: '#88BEE0',
          }
        }],

        legend: {
          top: 'center',
          right: '0%',
          orient: 'vertical',
          icon: 'roundRect',
          textStyle: {
            color: '#fff',
            fontSize: '12',
          }
        },
        color: ['#3F95F7', '#C69116', '#56BD79'],
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['45%', '60%'],
            left: '-30%',
            avoidLabelOverlap: false,
            label: {
              show: true,
              formatter: '{b}\n{c}',
              // position: 'center'
            },
            // emphasis: {
            //   label: {
            //     show: true,
            //     fontSize: 40,
            //     fontWeight: 'bold'
            //   }
            // },
            labelLine: {
              show: true
            },
            data: [
              // { value: 1048, name: '巡查完' },
              // { value: 735, name: '巡查中' },
              // { value: 580, name: '待巡查' },
              { value: 0, name: '巡查完' },
              { value: 0, name: '巡查中' },
              { value: 0, name: '待巡查' },

            ]
          }
        ]

      };
      myChart.setOption(option);
    },
    pieInit () {
      let chartDom = document.getElementById('echarts1');
      let myChart = Echarts.init(chartDom);
      let option = {

        tooltip: {
          show:false,
          trigger: 'item'
        },

        color: ['#6DEBD0', '#3F95F7', '#56BD79', '#514CC7'],
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: [20, 60],

            center: ['50%', '50%'],
            data: [
              // { value: 335, name: '水位水压' },
              // { value: 310, name: '漏电保护' },
              // { value: 274, name: '气体报警' },
              // { value: 235, name: '消防通道' },
              { value: 0, name: '水位水压' },
              { value: 0, name: '漏电保护' },
              { value: 0, name: '气体报警' },
              { value: 0, name: '消防通道' },
            ].sort(function (a, b) {
              return a.value - b.value;
            }),
            roseType: 'radius',
            label: {
              // color: 'rgba(255, 255, 255, 1)',
              formatter: '{b}\n{c}',
            },
            labelLine: {
              // lineStyle: {
              //   color: 'rgba(255, 255, 255, 0.3)'
              // },
              smooth: 0.2,
              length: 10,
              length2: 20
            },
            itemStyle: {

              shadowBlur: 200,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            },
            animationType: 'scale',
            animationEasing: 'elasticOut',
            animationDelay: function (idx) {
              return Math.random() * 200;
            }
          }
        ]
      };
      myChart.setOption(option);
    },


    categoryInit () {
      let chartDom = document.getElementById('echarts2');
      let myChart = Echarts.init(chartDom);
      let option = {
        grid: {
          bottom: '15%',
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['10.27', '10.28', '10.29', '10.30', '10.31', '11.01', '11.02'],
          axisLabel: {
            //x轴文字的配置
            show: true,
            textStyle: {
              color: "rgba(219,225,255,1)",
            },
          },
        },
        yAxis: {
          type: 'value',
          show: false
        },
        lineStyle: {
          width: 1,//外边线宽度
          color: '#2075FF'//外边线颜色
        },
        series: [
          {
            emphasis: {
              label: {
                show: true,
                fontSize: 18,
                fontWeight: 'bold',
                color: '#fff'
              }
            },
            data: [32, 23, 32, 45, 67, 54, 45],
            type: 'line',
            areaStyle: {//区域填充渐变颜色
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#2075FF' // 0% 处的颜色
                }, {
                  offset: 1, color: '#0D121C' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              }
            }
          }
        ]
      };
      myChart.setOption(option);
    },


    axisInit () {
      let chartDom = document.getElementById('echarts3');
      let myChart = Echarts.init(chartDom);
      let option = {
        color: ['#54B5FF', '#FFE434',],
        title: {
          show: false,
          text: 'Customized Radar Chart'
        },
        legend: {
          orient:"vertical",
          right:'0%',
          top:'50%',
          textStyle:{
            color:'#fff',
            fontSize:12
          },
          data:[
            { 
              icon:'image://https://school.zzsasoft.com/uploads/images/new/1.png',
              name: '温度',
            },
            { 
              icon:'image://https://school.zzsasoft.com/uploads/images/new/2.png',
              name: '湿度',
            }
            ]
        },
        radar: [
          {
            indicator: [
              { text: '温度',max: 600  },
              { text: '湿度',max: 600 },
              { text: '风级',max: 600 },
              { text: '天气',max: 600 },
              { text: '预期',max: 600 },
              { text: '其他',max: 600 }

            ],
            padding:[0,0,0,0],
            center: ['45%', '50%'],
            radius: 80,
            startAngle: 90,
            splitNumber: 4,
            // shape: 'circle',
            axisName: {
              formatter: '【{value}】',
              color: '#428BD4'
            },
            splitArea: {
              areaStyle: { 
                color: [ 'rgba(5, 133, 250, 0.100)'],
                shadowColor: 'rgba(0, 0, 0, 0.2)',
                shadowBlur: 10
              }
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(211, 253, 250, 0.8)'
              }
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(84, 181, 255, .36)'
              }
            }
          },
        ],
        series: [
          {
            type: 'radar',
            emphasis: {
              lineStyle: {
                width: 4
              }
            },
            data: [
              {
                // value: [400, 508,300,500,400,400],
                value: [0, 0,0,0,0,0],
                name: '温度',
                lineStyle: {
              
                  color:'rgba(63, 149, 247, 1)'
                },
                 
                areaStyle: {
                  // color: 'rgba(63, 149, 247, .9) '
                 color: new Echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                          {
                            color: ' rgba(63, 149, 149, 0)',
                            offset: 0
                          },
                          {
                            color: 'rgba(63, 149, 247, 1)',
                            offset: 1
                          }
                        ])
                }
              },
            
              {

                // value: [300,500,400,500, 408,300,],
                value: [0, 0,0,0,0,0],
                name: '湿度',
                lineStyle: {
              
              color:'rgba(86, 189, 121, 1)'
            },
                areaStyle: {
                  // color: 'rgba(86, 189, 121, 1)'
                 color: new Echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                          {
                            color: 'rgba(86, 189, 121, 0)',
                            offset: 0
                          },
                          {
                            color: 'rgba(86, 189, 121, 1)',
                            offset: 1
                          }
                        ])
                }
              }
            ]
          },
          // {
          //   type: 'radar',
          //   radarIndex: 1,
          //   data: [
          //     {
          //       value: [120, 118, 130, 100, 99, 70],
          //       name: 'Data C',
          //       symbol: 'rect',
          //       symbolSize: 12,
          //       lineStyle: {
          //         type: 'dashed'
          //       },
          //       label: {
          //         show: true,
          //         formatter: function (params) {
          //           return params.value;
          //         }
          //       }
          //     },
          //     {
          //       value: [100, 93, 50, 90, 70, 60],
          //       name: 'Data D',
          //       // areaStyle: {
          //       //   color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
          //       //     {
          //       //       color: 'rgba(255, 145, 124, 0.1)',
          //       //       offset: 0
          //       //     },
          //       //     {
          //       //       color: 'rgba(255, 145, 124, 0.9)',
          //       //       offset: 1
          //       //     }
          //       //   ])
          //       // }
          //     }
          //   ]
          // }
        ]
      };
      myChart.setOption(option);
    },






  },
};















var targetHeightScale; //存放缩放的比例
var autoResize = {
  resize: function (docWidth, docHeight, targetSelector) {
    var docScale = docHeight / docWidth,
      designWidth = 1920,
      designHeight = 940,
      els = document.querySelectorAll(targetSelector),
      scale = docWidth / designWidth,
      scaleX = docWidth / designWidth,
      scaleY = docHeight / designHeight,
      _this = this;
    (targetHeightScale = scale), //将缩放比例保存，动态计算宽高时需要使用
      this.convertArray(els).forEach(function (el) {
        _this.extend(el.style, {
          width: designWidth + "px",
          height: docScale * designWidth + "px",
          position: "absolute",
          top: 0,
          left: 0,
          transformOrigin: "0 0",
          webkitTransformOrigin: "0 0",
          transform: "scale(" + scale + ")",
          webkitTransform: "scale(" + scale + ")",
          overflow: "hidden",
          webkitOverflowScrolling: "touch"
        });
      });
  },
  convertArray: function (arrayLike) {
    return Array.prototype.slice.call(arrayLike, 0);
  },
  extend: function () {
    var args = Array.prototype.slice.call(arguments, 0);
    return args.reduce(function (prev, now) {
      for (var key in now) {
        if (now.hasOwnProperty && now.hasOwnProperty(key)) {
          prev[key] = now[key];
        }
      }
      return prev;
    });
  },
  scaleResize: function (clientWidth, clientHeight, targetSelector) {
    window.addEventListener(
      "resize",
      this.resize(clientWidth, clientHeight, targetSelector)
    ); //监听窗口的变化
  }
};
var setElementSize = {
  //参数可选，最多选择5个参数。参数按序赋值，如果不需缩放，scale需传入1
  setSize: function (target, scale, target1, target2, target3) {
    var targetScale = scale || 1; //不传scale，不缩放，默认为1
    var targetHeight;
    if (target) {
      targetHeight = innerHeight / targetScale;
    }
    // console.log(targetHeight)
    // if (target1) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height();
    // }
    // if (target1 && target2 && target3) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height() -  document.querySelector(target2).height() -  document.querySelector(target3).height();
    // } else if (target1 && target2) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height() -  document.querySelector(target2).height();
    // } else if (target1) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height();
    // }
    document.querySelector(".bigdata_page").style.height = targetHeight;

    // var cancas =  document.getElementsByTagName('canvas')
    // var ss = document.getElementsByTagName('canvas')

    // console.log(ss)

    // document.getElementsByTagName('canvas').setAttribute('height','100%')
    // document.getElementsByTagName('canvas').setAttribute('width','100%')
    // console.log(cancas)
    // cancas.width = '100px'
    // cancas.height = '100px'

    // console.log(123)
    // console.log(document.querySelector('.bigdata_page').offsetHeight)
  }
};
var is_fullScreen = false;

window.onresize = function () {
  if (is_fullScreen) {
    changeHeight();
  } else {
    cancelChangeHeight();
  }
  console.log(targetHeightScale)
  autoResize.scaleResize(innerWidth, innerHeight, ".bigdata_page");
  setElementSize.setSize(".bigdata_page", targetHeightScale);
  // setElementSize.setSize('.left_top', targetHeightScale, '.top')
  // setElementSize.setSize('.map', targetHeightScale, '.top', '.left_bottom');
  // setElementSize.setSize('.right_body', targetHeightScale, '.top');
};
autoResize.scaleResize(innerWidth, innerHeight, ".bigdata_page");
setElementSize.setSize(".bigdata_page", targetHeightScale);
// 全屏状态时更改高度
function changeHeight () {
  is_fullScreen = true;
}

// 取消全屏时恢复
function cancelChangeHeight () {
  is_fullScreen = false;
}
</script>
<style lang="scss">
.fireFighting {
  // .el-progress-circle{
  //   width:94px !important;
  //   height:94px !important;
  // }
  .el-progress__text {
    font-size: 24px !important;
    left: 10px !important;
  }
  p,
  span,
  em,
  i,
  a {
    font-style: normal;
    text-decoration: none;
    font-size: 14px;
  }
  .flex {
    display: flex;
    justify-content: space-between;
  }
  .block {
    display: block;
    width: 80px;
    margin: 0 auto 10px;
  }
  .fc1 {
    font-size: 14px;
    color: #b4b8c1;
    font-family: MicrosoftYaHei;
  }
  .fc2 {
    font-family: DINCondensed, DINCondensed;
    font-weight: bold;
    font-size: 20px;
    color: #00fff9;
  }
  .fs36 {
    font-size: 36px;
  }
  .fs24 {
    font-size: 24px;
  }
  .alignCenter {
    display: block;
    text-align: center;
  }
  .mgtop-10 {
    margin-top: 10px;
  }
  .mgtop-20 {
    margin-top: 20px;
  }
  .mgtop-28 {
    margin-top: 28px;
  }
  .btn {
    color: #fff;
    display: inline-block;
    padding: 9 18px;
    border: 1px solid #153c7a;
  }
  .btn2 {
    // width:100px;
    // height:100px;
    // border:1px solid #153c7a;
    position: relative;
    color: #0fd1ff;
    display: flex;
    // line-height:68px;
    font-size: 24px;
    text-align: center;
    & > span:last-child {
      background: #153c7a;
      width: 100%;
      display: block;
      color: #fff;
      position: absolute;
      bottom: 0;
      height: 32px;
      line-height: 32px;
    }
  }
}
</style>
<style lang="scss" scoped>
.fireFighting {
  width:100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  padding: 0 20px ;
  // background-color: #010734;
  .top_nav {
    width: 1126px;
    height:68px; //
    margin: 0 auto;
    cursor: pointer;
    background: url('~@/assets/fireFighting/title.png') no-repeat 0;
    background-size: 100% 100%;
    font-family: PangMenZhengDao-3, PangMenZhengDao;
    font-size: 48px;
    color: #fff;
    text-align: center;
    p {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 42px;
      // color: #00D0FF;
      line-height: 58px;
      // text-shadow: 0px 3px 5px #07216b;
      text-align: center;
      font-style: normal;
      // background: linear-gradient(270deg, #000 0%, #B9ECFF 63%, #fff 100%);
      background: linear-gradient(0deg, #02a9c6 0%, #b9ecff 63%, #f4f5ff 100%),
        linear-gradient(
          269.9969528196809deg,
          #0043ff 0%,
          #00d0ff 56%,
          #edfbff 100%
        );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  // .title{
  //   width:370px;
  //   height: 42px;
  //   background:url("~@/assets/fireFighting/titleBg.png") no-repeat 0;
  //   background-size: cover;
  //   line-height:42px;
  //   text-indent:20px;
  //   color:#fff;
  //   margin:15px 0 10px 0;
  // }
  .content {
    display: flex;
    justify-content: space-between;
    height:90vh;
    // padding-bottom: 20px;
    & > div > .box {
      // width:400px;
      padding: 0 15px 10px;
      color: #fff;
      margin-bottom: 15px;
    }
    .contentBox {
      flex: 1;
      padding: 0 20px;
      display: flex;
    flex-direction: column;
    justify-content: space-between;
      .adress {
        text-align: center;
        // height: 590px ;//
        flex:1;
        background: url('~@/assets/fireFighting/new/address.png') no-repeat 0;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        margin-left:40px;
        // height:788px;
        // background-size:1279px 786px;
        background-size: 115%;
        background-position: center;
        .middle {
          background: url('~@/assets/fireFighting/new/middle.png') no-repeat 0;
          background-size: 100% 100%;
          width: 233px;
          position: relative;
          height: 277px;
          margin-bottom:60px;
          margin-right:20px;
          // padding-top: 40px;
          strong {
            font-size: 66px;
           line-height: 277px;
            color: #ffb713;
          }
          p {
            background: url('~@/assets/fireFighting/new/score.png') no-repeat 0;
            background-size: 100% 100%;

            width:175px;
            height:72px;
            font-size: 24px;
            position: absolute;
            font-family: MicrosoftYaHei;
            line-height:72px;
            left: 0;
            right: 0;
            margin: auto;
            bottom: -48px;
            color: #fff;
          }
        }
        .floatB {
          width: 102px;
          height: 102px;
          position: absolute;

          margin: auto;
          font-size: 19px;
          color: #fff;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          div {
            font-size: 24px;
            line-height: 24px;
            color: #ffffff;
            background: linear-gradient(
              77.99965581547701deg,
              #00d4ff 0%,
              #b8f0ff 100%
            );
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }

        @-webkit-keyframes bounce-down {
          25% {
            -webkit-transform: translateY(-4px);
          }
          50%,
          100% {
            -webkit-transform: translateY(0);
          }
          75% {
            -webkit-transform: translateY(4px);
          }
        }

        @keyframes bounce-down {
          25% {
            transform: translateY(-4px);
          }
          50%,
          100% {
            transform: translateY(0);
          }
          75% {
            transform: translateY(4px);
          }
        }
        @-webkit-keyframes bounce-down1 {
          25% {
            -webkit-transform: translateX(-6px);
          }
          50%,
          100% {
            -webkit-transform: translateX(0);
          }
          75% {
            -webkit-transform: translateX(6px);
          }
        }

        @keyframes bounce-down1 {
          25% {
            transform: translateX(-6px);
          }
          50%,
          100% {
            transform: translateX(0);
          }
          75% {
            transform: translateX(6px);
          }
        }

        .top {
          top: 0;
          right: 0;
          left: 0;
          background: url('~@/assets/fireFighting/new/y3.png') no-repeat 0;
          background-size: 100% 100%;
          -webkit-animation: bounce-down 1.6s linear infinite;
          animation: bounce-down 1.6s linear infinite;
        }
        .float_right1 {
          top: 90px;
          right: 120px;
          background: url('~@/assets/fireFighting/new/y3.png') no-repeat 0;
          background-size: 100% 100%;
          -webkit-animation: bounce-down 2.6s linear infinite;
          animation: bounce-down 2.6s linear infinite;
        }
        .float_left1 {
          top: 200px;
          left: 230px;
          background: url('~@/assets/fireFighting/new/y2.png') no-repeat 0;
          background-size: 100% 100%;
          -webkit-animation: bounce-down 3.6s linear infinite;
          animation: bounce-down 3.6s linear infinite;
        }
        .float_right2 {
          top: 240px;
          right: 230px;
          background: url('~@/assets/fireFighting/new/y3.png') no-repeat 0;
          background-size: 100% 100%;
          -webkit-animation: bounce-down 2s linear infinite;
          animation: bounce-down 2s linear infinite;
        }
        .float_left2 {
          top: 460px;
          left: 160px;
          background: url('~@/assets/fireFighting/new/y2.png') no-repeat 0;
          background-size: 100% 100%;
          -webkit-animation: bounce-down 4s linear infinite;
          animation: bounce-down 4s linear infinite;
        }

        .bottom {
          width: 88px;
          height: 88px;
          bottom: 34px;
          right: -440px;
          left: 0;
          background: url('~@/assets/fireFighting/new/y1.png') no-repeat 0;
          background-size: 100% 100%;
          -webkit-animation: bounce-down 2s linear infinite;
          animation: bounce-down 2s linear infinite;
        }
      }
    }
    .rightBox {
      .nowDevice {
        ul > li {
          line-height: 16px;
          & > span:first-child {
            width: 50px;
          }
        }
      }
      .proportion {
        width: 260px;
        height: 16px;
        display: block;
        background: #0d2750;
        em {
          display: block;
          height: 16px;
          background: #3182ff;
        }
      }
    }
  }
  .footer {
    display: flex;
    justify-content: space-between;
    & > .box {
      width: 400px;
      padding: 0 15px;
      color: #fff;
      border: 1px solid rgba(0, 122, 255, 0.25);
      margin-bottom: 20px;
    }
    & > div:first-child {
      width: 50%;
    }
    .footer_first {
      ul {
        position: relative;
        li > span {
          display: block;
          width: 56px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          color: #2075ff;
          border: 1px solid #2075ff;
          border-radius: 4px;
          margin-top: 10px;
          cursor: pointer;
        }
        li > .active {
          background: #2075ff;
          color: #fff;
        }
        li > div {
          width: calc(100% - 66px);
          height: 140px;
          float: right;
          display: flex;
          justify-content: space-between;
          position: absolute;
          top: 5px;
          left: 70px;
          & > div {
            width: 140px;
            height: 140px;
            position: absolute;
            &:first-child {
              background: url('~@/assets/fireFighting/circleLeft.png') no-repeat
                0;
              background-size: cover;
              left: 0;
              color: #ff6d00;
            }
            &:nth-child(2) {
              line-height: 60px;
              right: -6px;
              color: #fff;
              background-size: cover;
              em {
                display: block;
                font-size: 18px;
                i {
                  font-size: 18px;
                }
                &:first-child {
                  margin-left: -23px;
                  color: #ff6d00;
                }
                &:last-child {
                  color: #ffa900;
                }
              }
            }
            &:last-child {
              background: url('~@/assets/fireFighting/circleRight.png')
                no-repeat 0;
              background-size: cover;
              right: -100px;
              color: #ffa900;
            }
            span {
              display: block;
              line-height: 140px;
              text-align: center;
              font-size: 28px;
            }
          }
        }
      }
    }
    .footer_second {
      ul > li {
        overflow: hidden;
        height: 24px;
        line-height: 24px;
        margin-bottom: 18px;
        span {
          display: block;
          float: left;
          color: #9eaec9;
          &:last-child {
            color: #fff;
            float: right;
            font-size: 24px;
          }
        }
        em {
          display: block;
          float: left;
          margin-left: 20px;
          height: 24px;
          background: linear-gradient(
            90deg,
            #2075ff 0%,
            rgba(32, 195, 255, 0) 100%
          );
        }
      }
    }
    .footer_third {
      ul > li {
        margin-top: 18px;
        span {
          color: #9eaec9;
          font-size: 14px;
        }
        em {
          color: #fff;
          font-size: 24px;
          margin-left: 10px;
        }
      }
    }
    .footer_fourth {
    }
  }
}
</style>
<style lang="scss">
.leftTop {
  padding: 0 20px 0 30px;
  ul {
    height: 100%;
    div {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #ffcc58;
      strong {
        font-family: DINAlternate, DINAlternate;
        font-weight: bold;
        font-size: 20px;
        color: #ffcc58;
        margin-right: 6px;
      }
    }
  }
}
.leftTop,
.right1 {
  position: relative;
  background: url('~@/assets/fireFighting/new/lefttop.png') no-repeat;
  background-size: 100% 100%;
  width: 409px;
  
  height: 143px;//
}
.right1 {
  padding: 10px 27px 0;
  ul,
  li,
  div {
    width: 100%;
    align-items: center;
  
  }
  strong {
    font-weight: 500;
    font-size: 16px;
    color: #e6bb56;
  }
  .textBox {
    margin: 10px 0 4px;
  }
  .progess {
    // width: 406px;
    position: relative;
    height: 3px;
    border-radius: 2px;
    background: rgba(216, 216, 216, 0.2);
  }
  .progess img {
    left: 0;
    width: 16px;
    height: auto;
    top: 0;
    bottom: 0;
    margin: auto;
    position: absolute;
  }
  .progessLine1 {
    height: 3px;
    background: linear-gradient(63deg, #044b9c 1%, #00fff9 100%);
    // width: 100px;
  }
  .progessLine2 {
    background: linear-gradient(63deg, #049c68 0%, #00ffa2 100%);
  }
  .progessLine3 {
    background: linear-gradient(63deg, #fe4700 0%, #ffce04 100%);
  }
}
.lefttop2 {
  position: relative;
  background: url('~@/assets/fireFighting/new/lefttop2.png') no-repeat;
  background-size: 100% 100%;
  width: 409px;
  margin: 12px 0;
  height: 211px;//
  ul {
    padding: 0 30px;
    div {
      width: 91px;
      display: block;
      height: 71px;
      font-family: DINCondensed, DINCondensed;
      font-weight: bold;
      font-size: 20px;
      color: #00fff9;
      background: url('~@/assets/fireFighting/new/lefttop2-1.png') no-repeat;
      background-size: 100% 100%;
    }
    span {
      margin-top: 12px;
      width: 94px;
      display: block;
      height: 27px;
      background: url('~@/assets/fireFighting/new/lefttop2-2.png') no-repeat;
      background-size: 100% 100%;
      font-size: 12px;
      color: #b4b8c1;
      line-height: 1;
    }
  }
}
.lefttop3 {
  margin-bottom: 10px;
  position: relative;
  background: url('~@/assets/fireFighting/new/lefttop3.png') no-repeat;
  background-size: 100% 100%;
  width: 409px;
  // height: 260px ;//
  height: 240px ;
  padding: 0 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .title {
    position: absolute;
  }
  div {
    img {
      width: 60px;
      height: 72px;
      margin-right: 12px;
    }
    .left3Btn {
      display: flex;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #b4b8c1;
      align-items: center;
      em {
        font-weight: bold;
        font-size: 20px;
        color: #00fff9;
        font-family: DINCondensed, DINCondensed;
      }
    }
  }
  .line {
    width: 1px;
    height: 145px;
    border: 1px solid;
    margin-left: 30px;
    border-image: linear-gradient(
        180deg,
        rgba(0, 255, 253, 0),
        rgba(0, 255, 251, 0.5),
        rgba(0, 255, 249, 0)
      )
      1 1;
  }
}

.mt12 {
  margin-top: 12px;
}
.left4 {
  position: relative;
  background: url('~@/assets/fireFighting/new/left4bg.png') no-repeat;
  background-size: 100% 100%;
  width: 409px;
  height:295px; 
  padding-top: 35px;
  .police {
    display: flex;
    padding: 0 14px;
    text-align: center;
    li {
      flex: 1;
    }
  }
  .policeItem {
    font-size: 12px;
    display: block;
    color: #54b5ff;
    display: flex;
    height: 22px;
    line-height: 22px;
    span {
      display: block;
      text-align: center;
      width: 100%;
      background-size: 100% 100%;
      background-image: url('~@/assets/fireFighting/new/left4-2.png');
    }
    .active {
      background-image: url('~@/assets/fireFighting/new/left4-1.png');
    }
  }
  .left4Bottom {
    width: 86px;
    text-align: center;
    img {
      width: 86px;
      height: auto;
      margin: 56px 0 29px;
    }
  }
}
.flex-column-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.padding56 {
  padding: 0 56px;
}
.right2 {
  background: url('~@/assets/fireFighting/new/lefttop2.png') no-repeat;
  background-size: 100% 100%;
  width: 409px;
  height: 179px; //
  position: relative;
  margin:10px 0;
}
.right3 {
  background: url('~@/assets/fireFighting/new/lefttop3.png') no-repeat;
  background-size: 100% 100%;
  width: 409px;
  height: 208px ; //
  position: relative;
  flex:1;
  display:flex;
  margin-bottom:10px;
  overflow:hidden;
}
.left2 {
  position: relative;
  background: url('~@/assets/fireFighting/new/left4bg.png') no-repeat;
  background-size: 100% 100%;
  width: 409px;
  padding: 30px 24px;
  display:flex;
  margin-bottom:10px;
  overflow:hidden;
  // height: 36.5vh ; 
  flex:1;
  // height: 335px ;
}
.right4 {
  position: relative;
  background: url('~@/assets/fireFighting/new/left4bg.png') no-repeat;
  background-size: 100% 100%;
  width: 409px;
  padding: 40px 24px;
  height: 255px; //
  .seamless-warp {
    height: 230px;
    overflow: hidden;
  }
  ul > li {
    margin-top: 10px;
    & > span:last-child {
      margin-left: 10px;
    }
  }
  img {
    width: 70px;
    height: auto;
  }
}
.centerLeft {
  background: url('~@/assets/fireFighting/new/centerleft.png') no-repeat;
  background-size: 100% 100%;
  width: 489px;
  height: 255px; //
  position: relative;
  padding: 0 45px 0 30px;
  ul {
    margin-top: 10px;
  }
  ul,
  li,
  div {
    width: 100%;
    align-items: center;
  }
  strong {
    font-weight: 500;
    font-size: 16px;
    color: #e6bb56;
  }
  .textBox {
    margin: 22px 0 7px;
  }
  .progess {
    width: 100%;
    height: 8px;
    border-radius: 2px;
    background: rgba(216, 216, 216, 0.2);
  }
  .progessLine {
    height: 8px;
  }
  .allXfplace {
    font-weight: 600;
    font-size: 14px;
    color: #ffffff;
    width: 204px;
    height: 57px;
    background: linear-gradient(
      180deg,
      rgba(0, 178, 255, 0.3) 0%,
      rgba(0, 133, 255, 0) 100%
    );
    border: 2px solid;
    line-height: 57px;
    text-align: center;
    // opacity: 0.3;
    border-image: linear-gradient(
        180deg,
        rgba(0, 213, 255, 0.5),
        rgba(0, 171, 255, 0)
      )
      2 2;
  }
  .allnum {
    background: url('~@/assets/fireFighting/new/centerright-1.png') no-repeat;
    background-size: 100% 100%;
    width: 182px;
    font-family: DINCondensed, DINCondensed;
    font-weight: bold;
    font-size: 40px;
    color: #ffcc58;
    text-align: center;
    height: 143px;
  }
  .clocks {
    width: 222px;
    height: 85px;
    padding: 0 28px;
    background: linear-gradient(
      0deg,
      rgba(0, 213, 255, 0.2),
      0%,
      rgba(0, 133, 255, 0) 100%
    );
    border: 1px solid;
    position: relative;
    justify-content: flex-start;
    // opacity: 0.2;
    border-image: linear-gradient(
        180deg,
        rgba(0, 213, 255, 0.5),
        rgba(0, 171, 255, 0)
      )
      1 1;
    span {
      font-weight: 600;
      font-size: 14px;
      color: #ffffff;
    }
    img {
      width: 7px;
      height: auto;
      margin-right: 10px;
    }
    em {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #ff4d21;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 28px;
      line-height: 85px;
      margin: auto;
    }
  }
}
.centerright {
  background: url('~@/assets/fireFighting/new/centerleft.png') no-repeat;
  background-size: 100% 100%;
  width: 489px;
  height: 268px ; //
}
.title {
  position: absolute;
  top: 0;
  left: 10px;
  font-weight: 500;
  font-size: 14px;
  color: #88bee0;
}
//暂无数据字体样式
.tipText{
  font-weight: 500;
  font-size: 14px;
  color: #b4b8c1;
  text-align: center;
}


.h100 {
  height: 100%;
}
.top2Line {
  width: 1px;
  height: 35px;
  border: 1px solid;
  border-image: linear-gradient(
      180deg,
      rgba(0, 255, 253, 0),
      rgba(0, 255, 251, 0.5),
      rgba(0, 255, 249, 0)
    )
    1 1;
}
.leftBox,
.rightBox {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
<style scoped>
.appBg {
  background: url('~@/assets/fireFighting/new/bg.png') no-repeat 0;
  background-size: cover;
  width: 100%;
  height: 100%;
  background-color: #010734;
  overflow: hidden;
}
#index {
  width: 1920px;
  height: 1080px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transform-origin: left top;
  overflow: hidden;
}
#index .bg {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center center;
}
.left3 {
  width: 409px;
  height: 255px;
}
#echarts3 {
  width: 360px;
  height: 100%;
}
.schoolSafe {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding:0 20px ;
  margin-top: 12px;
}
.schoolSafe p{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex:1;
  font-size: 12px;
color: #B4B8C1;
}
.schoolSafe .sort{
  width: 26px;
  height: 27px;
  background-image: url('~@/assets/fireFighting/sc4.png');
  text-align: center;
  line-height: 27px;
  background-size: 100% 100%;
  font-family: PingFangSC, PingFang SC;
  font-size: 14px;
  margin-right:5px;
}
.schoolSafe  .frist{
  background-color: #56bd79;

}
.smallBox {
  margin-left: 3px;
  width: 3px;
  height: 14px;
  display: block;
  background-color: #1B7FC6;

}
.schoolSafe .line {
  width: 106px;
  color: rgba(37, 176, 255, 1);
  background-color: #1B7FC6;
  border-top: 1px dashed rgba(173, 177, 188, .8);
  margin:0 5px;

}
.schoolSafe  .second{
  border-top: 1px dashed rgba(255, 131, 18, 0.8);
  background: #FF8312;
}

.schoolSafe  .third{
  border-top: 1px dashed rgba(255, 184, 18, .8);
  background: rgba(255, 184, 18, 1);
}
.fristColor{
    color: #56bd79;
}
.secondColor{
  color:#FF8312;
}
.thirdColor{
  color: rgba(255, 184, 18, 1);
}
.schoolSafe p {
  width: 106px;
  margin-bottom: 0;
}
.schoolSafe img {
  width: 26px;
  height: 27px;
  margin-right:5px;
}
.boxContainer {
  width: auto;
  display: flex;
  margin-right:5px;
}


.right3 {
}
.right3 img {
  width: 52px;
}
.noticeItem {
  width: 352px;
  height: 86px;
  display: flex;
  position: relative;
}
.noticeItem::before {
  clear: both;
  height: 60px;
  position: absolute;
  width: 1px;
  bottom: 0;
  left: 12px;
  background: rgba(180, 184, 193, 0.3);
  content: '';
}
.noticeItem .line {
  border: 1px dashed #b73147;
  width: 35px;
  height: 1px;
  margin: 10px 2px 0;
}
.noticeItem img {
  width: 24px;
  height: 24px;
}
.noticeItem .item_right {
}

.noticeItem .faultLine{
  border: 1px dashed #1B7FC6;

}
.noticeItem .item_right p {
  padding-left: 32px;
  width: 220px;
  height: 20px;
  background: url('~@/assets/fireFighting/new/red.png') no-repeat 0;
  background-size: 100% 100%;
  color: rgba(255, 255, 255, .7);
}

.noticeItem .defaultRight p{
  background: url('~@/assets/fireFighting/new/grey.png') no-repeat 0;
  color: rgba(255, 255, 255, .7);
  background-size: 100% 100%;

}

.noticeItem .item_right span {
  font-weight: 400;
  font-size: 12px;
  color: #b4b8c1;
  
}
.noticeItem .item_right .deal {
  font-weight: 400;
  font-size: 12px;
  margin-top: 10px;
  color: #1e80cc;
}
#echartsCenterLeft {
  width: 460px;
  height: 100%;
}
.right4_item {
  font-size: 12px;
  color: #b4b8c1;
  display: flex;
  align-items: center;
  line-height: 25px;
}
.right4_item .danger {
  background: url('~@/assets/fireFighting/new/danger.png') no-repeat 0;
  background-size: 100% 100%;
  width: 106px;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 20px;
  font-size: 10px;
  line-height: 20px;
  margin-right: 7px;
  padding: 0 14px 0 7px;
}
.right4_item .waring{
  width: 106px;
}
.right4_item .default{
  width: 106px;
}
.dangerColor {
  color: #f24e4e;
  padding-left: 5px;
}
.warnColor {
  color: rgba(255, 183, 19, 1);
}
.right4_item .line {
  display: inline-block;
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.right4_item .lineWidth {
  width: 150px;
}
.right4_item .resourceName {
  width: 60px;
}
.right4_item .resourceNameWidth{
  width: 100px;
  margin-left: 5px;
}
ul,li{
  margin-bottom:0;
}
</style>